module.exports = __webpack_public_path__ + "img/26.fb421226.png";